/* 
  许可证激活组件
 */
<template>
  
 <div >

   <!-- 许可证模态框 -->
   <a-modal centered title="激活" :keyboard="false" :visible="modalVisible" :closable="closableReset" :confirm-loading="submitLoad" width="700px"
            :dialog-style="{ top: '-50px' }" footer @cancel="resetOpen" :maskClosable="false">
     <!-- 激活 -->
     <div>
       <a-steps :current="current">
         <a-step v-for="item in steps" :key="item.title">
           <template slot="title">
             {{ item.title }}
           </template>
         </a-step>
       </a-steps>
       <a-spin :spinning="submitLoad">
         <div class="steps-content">

           <div v-if="steps[current].title == '申请许可证文件'" class="steps-apply">
             <div class="steps-tips">
               <h3>Tips: 如何申请许可证文件?</h3>
               <P><span>①</span> 截图或拍照保存二维码图片</P>
               <P><span>②</span> 向管理员申请许可证文件并保存至电脑</P>

               <p>注: 如已加载出的设备相关信息不符合预期，可进行手动刷新</p>
             </div>
             <a-button type="primary" icon="redo" @click="refreshQr">刷新</a-button>

             <div class="qrcode" ref="qrCodeUrl" id="qrcodeId"></div>

           </div>

           <div v-if="steps[current].title == '上传许可证文件'" class="steps-upload">
             <a-upload-dragger name="file" :file-list="fileList" :remove="handleRemove" accept='.lic' :multiple="true"
                               :before-upload="beforeUpload" @change="handleChange" :showUploadList="false">
               <p class="ant-upload-drag-icon">
                 <a-icon type="file" v-if="this.fileList.length == 1" />
                 <a-icon type="inbox" v-else />
               </p>

               <p class="ant-upload-text" style="color:#769df1">

                 {{ this.fileList.length == 1 ? this.fileNmae : '点击上传许可证文件，或将文件拖拽到此处' }}
               </p>
               <p class="ant-upload-hint">
                 {{ this.fileList.length == 1 ? '重新选择' : '支持后缀lic' }}
               </p>
             </a-upload-dragger>
           </div>

           <div v-if="steps[current].title == '激活许可证文件'" class="steps-activation">
             <div class="steps-activation-box">
               <img src="../../../assets/images/ac_succeeded.png" alt="">
               <h2>激活成功!</h2>
               <p>恭喜,您已成功激活许可证文件</p>
             </div>
           </div>

         </div>
       </a-spin>

       <div class="steps-action">
         <div class="steps-version">
            <span>
            系统版本：{{versionData.systemVersion}}
            </span>
         </div>
         <div class="steps-btn">
           <a-button v-if="current < steps.length - 1 && current == 0" type="primary" @click="next">
             已有许可证文件,下一步
           </a-button>

           <a-button v-if="current == 2" style="margin-left: 8px" @click="complete">
             完成
           </a-button>

           <a-button type="primary"  v-if="current == 1" :loading="uploading" :disabled="fileList.length === 0" style="margin-left: 8px"
                     @click="handleUpload">
             导入并激活
           </a-button>

           <a-button v-if="current > 0 && current == 1" style="margin-left: 8px" @click="back">
             上一步
           </a-button>
         </div>

       </div>
     </div>
   </a-modal>
</div>



    
</template>

<script>
// 引入vueX状态管理库
import store from '@/store'
// 引入vue路由
import router from '@/router'
// 引入二维码生成
import QRCode from 'qrcodejs2'

export default {
  data(){
    return {
      // 弹出框显隐
      modalVisible: false,
      // 按钮加载
      uploading:false,
      submitLoad: false,
      // 步骤条
      current: 0,
      // 文件列
      fileList:[],
      // 许可证关闭按钮显隐
      closableReset:true,
      // 更新版本内容
      versionData:{},
      steps: [
        {
          title: '申请许可证文件',
        },
        {
          title: '上传许可证文件',
        },
        {
          title: '激活许可证文件',
        },
      ],
    }
  },
  methods: {
    // 生成二维码
    creatQrCode() {
      this.submitLoad = true;
      this.axios
          .post('/license/getLicenseInfo')
          .then((res) => {
            if (res.code == 200) {
              this.submitLoad = false
              let obj = JSON.stringify(res.data)
              setTimeout(() => {
                new QRCode(this.$refs.qrCodeUrl, {
                  text: obj,
                  width: 260,
                  height: 260,
                  colorDark: '#000000',
                  colorLight: '#ffffff',
                  render: "canvas",
                  correctLevel: QRCode.CorrectLevel.L,
                })
                document.getElementById("qrcodeId").title = ''
              }, 0)
            }
          })
          .catch((err) => {
            this.submitLoad = false
            console.log(err);
          });
    },

    // 刷新二维码
    refreshQr() {
      this.creatQrCode()
      this.$refs.qrCodeUrl.innerHTML = ''
    },

    // 激活许可证-下一步
    next() {
      this.current++;
    },

    // 激活许可证-完成
    complete() {
      this.current = 0
      this.modalVisible = false
      location.reload()
    },

    // 激活许可证-上一步
    back() {
      if (this.current == 1) {
        this.fileList = [];
        this.creatQrCode();
      }
      this.current--;
    },

    // 监听文件上传
    handleChange(data) {
      this.fileNmae = data.file.name
    },

    // 移出文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },

    // 判断是否上传文件
    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
      //限制文件只能上传一个
      this.fileList = this.fileList.slice(-1);
      return false;
    },

    // 上传文件
    handleUpload() {
      const { fileList } = this;
      const formData = new FormData();
      fileList.forEach(file => {
        formData.append('file', file);
      });
      this.uploading = true;

      this.axios
          .post('/license/save', formData)
          .then((res) => {
            if (res.code == 200) {
              this.fileList = [];
              this.current = 2
              this.uploading = false;
            } else {
              this.uploading = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 系统信息
    systemInfo(){
      this.axios.get('/common/findGlobalConfiguration')
          .then((res) => {
            if (res.code === 200) {
              this.versionData = res.data
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 许可证模态框关闭
    resetOpen() {
      this.modalVisible = false;
      if (this.current == 0) {
        this.$refs.qrCodeUrl.innerHTML = ''
      }
      this.fileList = [];
      this.current = 0

      // 已弹窗CODE集合，处理重复弹窗的问题
      let errorCodes = JSON.parse(sessionStorage.getItem('errorCodes')) || []
      errorCodes = errorCodes.filter(i=>{   return (![426,424,423].includes(i))})
      sessionStorage.setItem('errorCodes', JSON.stringify(errorCodes))

    },

  },
  beforeMount(){
    this.creatQrCode()
    this.systemInfo()
  }
}
</script>

<style >
::v-deep .ant-progress-text {
  font-size: 25px;
  font-weight: 600;
}


.steps-content {
  margin-top: 10px;

  .steps-apply {
    .steps-tips {
      font-size: 13px;
      font-weight: 600;

      h3 {
        font-weight: 600;
        font-size: 13px;
      }

      p {
        margin: 0px;
      }

      p:nth-child(4) {
        color: #909090;
        margin-top: 15px;
        font-size: 12px;
      }
    }

    .qrcode {
      margin: 20px 0 50px 200px;
    }

    .ant-btn {
      position: absolute;
      right: 20px;
      margin-top: -30px;
    }
  }

  .steps-upload {
    width: 410px;
    margin-left: 125px;
    padding: 40px 0 50px 0;

    .ant-upload {
      height: 280px;
    }


  }


}
.steps-activation {
  .steps-activation-box {
    text-align: center;
    margin: 50px 0 50px 0;

    img {
      margin-bottom: 2em;
    }

  }
}
.steps-action {
  border-top: 1px #d7dde4 solid;
  padding: 15px 0 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .steps-version{
    font-size: 17px;
    font-weight: 600;
  }
}

</style>